var map = {
	"./01_hparc_IKA_Innenperspektive.jpg": 4921,
	"./02_hparc_IKA_Lageplan.jpg": 8961,
	"./03_hparc_IKA_Grundriss Erdgeschoss.jpg": 9127,
	"./04_hparc_IKA_Grundriss Obergeschoss.jpg": 4738,
	"./05_hparc_IKA_Schnitt.jpg": 8312,
	"assets/b2_nikolai-church/01_hparc_IKA_Innenperspektive.jpg": 4921,
	"assets/b2_nikolai-church/02_hparc_IKA_Lageplan.jpg": 8961,
	"assets/b2_nikolai-church/03_hparc_IKA_Grundriss Erdgeschoss.jpg": 9127,
	"assets/b2_nikolai-church/04_hparc_IKA_Grundriss Obergeschoss.jpg": 4738,
	"assets/b2_nikolai-church/05_hparc_IKA_Schnitt.jpg": 8312
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7236;